import script from "./ProyectsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ProyectsTable.vue?vue&type=script&setup=true&lang=js"

import "./ProyectsTable.vue?vue&type=style&index=0&id=cad14a7e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cad14a7e"]])

export default __exports__